import moment from 'moment'

export const getFirstDayOfWeek = () => {
    let now = moment();

    if (now.day() > 0) {
        now.day(1);
    }
    else {
        now.day(8);
    }

    now.startOf('day');

    return now;
}